'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Menu button component!
 *
 * @type {Function}
 */

var ToolbarMenu = function ToolbarMenu(_ref) {
  var type = _ref.type,
      icon = _ref.icon,
      title = _ref.title,
      menus = _ref.menus,
      onMenuToggle = _ref.onMenuToggle,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ToolbarButton2.default, { icon: icon, title: title, onMouseDown: function onMouseDown(e) {
        return onMenuToggle(e, type);
      } }),
    _react2.default.createElement(
      'div',
      { className: 'menu_' + type, style: { display: menus[type] ? 'block' : 'none' } },
      children
    )
  );
};

ToolbarMenu.propTypes = {
  type: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  menus: _propTypes2.default.object.isRequired,
  onMenuToggle: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired
};

exports.default = ToolbarMenu;